import React from 'react';

import { Ball, Icons } from 'widget/components';
import { Modal } from 'widget/content/components';
import { useContentContext } from 'widget/content/content-context';
import { useWidgetContext } from 'widget/widget-context';

const Callback = () => {
  const { isWidgetActive, widget } = useWidgetContext();
  const { setIsCallbackActive } = useContentContext();

  return (
    <>
      {widget.type == 'horizontal' ? (
        <Modal isActive={isWidgetActive} />
      ) : (
        <Ball onClick={() => setIsCallbackActive(true)}>
          <Icons.PhoneCall fill="contrast" />
        </Ball>
      )}
    </>
  );
};

export default Callback;
